export const base_Url = 'http://192.168.1.19:5050/api/';
export const base_Url_Assets = 'https://onlineparttimejobs.in/api/';